module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAaElEQVRYhe2WsQ2AMBADPUJGYARGsOTPnIzCCIzACIwATdJQoigvJJ/k+q40YMxASBaSJU0uaZN0To/o8oi4245M+VVrXS233HLLhxIRe2qAIxzhCEd8iJh3yd4R7ZQuKQEAkCo3v+QBz0ys5M4YTe4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/left.png
// module id = xDWF
// module chunks = 1